/**
 * Texto a mostrar para `responseMips`, la respuesta de MIPS (Assist Cargo) guardada en cada póliza.
 * Misma regla que el backend (tryger-backend/src/helpers/responseMips.ts):
 *
 * | Valor guardado               | Se muestra       |
 * | ---------------------------- | ---------------- |
 * | `{ idViaje, ... }`           | el idViaje       |
 * | `{ error: true, message }`   | el mensaje       |
 * | vacío                        | "Sin respuesta"  |
 *
 * Datos anteriores a este formato: `0` (fallo sin motivo) se muestra como "Error",
 * y `'null'` o un JSON inválido como "Sin respuesta".
 */
const MIPS_NO_RESPONSE = 'Sin respuesta';
const MIPS_UNKNOWN_ERROR = 'Error';

type StoredResponseMips = { idViaje?: number; error?: boolean; message?: string };

const parseResponseMips = (responseMips: string): StoredResponseMips | null => {
  try {
    return JSON.parse(responseMips);
  } catch {
    return null;
  }
};

export const describeResponseMips = (responseMips?: string | number | null): string | number => {
  if (responseMips === 0 || responseMips === '0') return MIPS_UNKNOWN_ERROR;
  if (!responseMips) return MIPS_NO_RESPONSE;

  const parsed = parseResponseMips(String(responseMips));
  if (parsed?.idViaje) return parsed.idViaje;
  if (parsed?.error) return parsed.message || MIPS_UNKNOWN_ERROR;
  return MIPS_NO_RESPONSE;
};
